import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes, useLocation} from 'react-router-dom';
import {isTokenValid} from './api';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import DocumentDetail from './pages/DocumentDetail';
import Templates from './pages/Templates';
import TemplateDetail from './pages/TemplateDetail';
import SigningPage from './pages/SigningPage';
import SignedDocumentPage from './pages/SignedDocumentPage';

function ProtectedRoute({ children }) {
  const location = useLocation();
  return isTokenValid() ? children : <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
}

function RootRedirect() {
  return isTokenValid() ? <Navigate to="/dashboard" replace /> : <Landing />;
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/documents/:id" element={<ProtectedRoute><DocumentDetail /></ProtectedRoute>} />
        <Route path="/templates" element={<ProtectedRoute><Templates /></ProtectedRoute>} />
        <Route path="/templates/:id" element={<ProtectedRoute><TemplateDetail /></ProtectedRoute>} />
        <Route path="/sign/:token" element={<SigningPage />} />
        <Route path="/sign/:token/document" element={<SignedDocumentPage />} />
      </Routes>
    </Router>
  );
}
